module.exports = __webpack_public_path__ + "sheep.2124ca38.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/content/sheep.svg
 ** module id = 111
 ** module chunks = 0
 **/